import React from "react";
import "../pages/Pages.css";
import { Image } from "react-bootstrap";
import OurExpertise from "./OurExpertise";
import AboutUs from "../pages/About";
import OurMission from "../pages/OurMission";
import OurDiffer from "../pages/OurDiffer";
import OurClients from "../pages/OurClients";
import TransformativeImpact from "../pages/TransformativeImpact";
import OurArbitrators from "../pages/OurArbitrators";
import FAQ from "../pages/FAQ";
import ContactUs from "../pages/ContactUs";
import Disclaimer from "../pages/Disclaimer";
import Footer from "../pages/Footer";
import banner from "../assets/images/banner.png";
import CustomNavbar from "./Navbar";

function Display() {
  return (
    <div className="homepage">
      <CustomNavbar />
      <div className="top-banner" id="homePage">
        <Image src={banner} alt="Resolution Experts Alliance Association" className="top-banner-img" />
        <div className="top-banner-content">
          <h2 className="top-banner-heading">
            Legal Access <span className="top-banner-highlight">Any Time Any Where</span>
          </h2>
          <p className="top-banner-text">
            Our organization operates at the intersection of law, technology and{' '}
            <br className="top-banner-break" />
            collaboration, offering clients a comprehensive suit of services that prioritize{' '}
            <br className="top-banner-break" />
            effeciency, cost-effectiveness and sustainable solutions.
          </p>
        </div>
      </div>

      <section id="ourexperties">
        <OurExpertise />
      </section>

      <section id="aboutUs">
        <AboutUs />
      </section>

      <section id="ourMission">
        <OurMission />
      </section>

      <section id="ourDiffer">
        <OurDiffer />
      </section>

      <section id="ourClients">
        <OurClients />
      </section>

      <section id="transformativeImpact">
        <TransformativeImpact />
      </section>

      <section id="ourArbitrators">
        <OurArbitrators />
      </section>

      <section id="faq">
        <FAQ />
      </section>

      <section id="contactUs">
        <ContactUs />
      </section>

      <section id="disclaimer">
        <Disclaimer />
      </section>

      <Footer />
    </div>
  );
}

export default Display;